const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i',
  й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't',
  у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch', ъ: '', ы: 'y', ь: '',
  э: 'e', ю: 'yu', я: 'ya',
};

function transliterate(value: string): string {
  return value
    .toLowerCase()
    .split('')
    .map((ch) => CYRILLIC_TO_LATIN[ch] ?? ch)
    .join('');
}

/** Strips a code down to what's actually allowed — Latin letters, digits,
 * underscore, lowercase. Meant to run on every keystroke so a code field can
 * never end up holding an invalid value in the first place. */
export function sanitizeCode(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9_]/g, '');
}

/** Auto-suggests a code from a human-entered name (layer/field) — transliterates
 * Cyrillic to Latin, then collapses everything that isn't a Latin letter/digit
 * into a single underscore (so "Точки Wi-Fi" -> "tochki_wi_fi", not "tochkiwifi").
 * Only a starting point: the user can freely edit it afterwards. */
export function slugify(value: string, fallback = 'code'): string {
  const slug = transliterate(value)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return slug || fallback;
}
